import { MinusCircledIcon, PlusCircledIcon } from "@radix-ui/react-icons";
import { Flex, Text, TextField } from "@radix-ui/themes";
import { styled } from "@stitches/react";

import { IconButton } from "../IconButton";

type Props = {
  onZoomIn?: () => void;
  onZoomOut?: () => void;
  onPageChange?: (newPage: number) => void;
  zoomLevel: number;
  currentPage: number;
  totalPages: number;
};

const ZoomButton = styled(IconButton, {
  background: "transparent",

  "&:hover": {
    background: "var(--gray-a10)",
  },
});

export const DocumentToolbar = ({
  onZoomIn,
  onZoomOut,
  onPageChange,
  currentPage,
  zoomLevel,
  totalPages,
}: Props) => {
  return (
    <Flex
      direction="row"
      align="center"
      gap="4"
      style={{
        background: "var(--gray-a11)",
      }}
      width="100%"
      p="1"
    >
      <Flex align="center" gap="1">
        <ZoomButton onClick={onZoomOut}>
          <MinusCircledIcon />
        </ZoomButton>
        <Text
          size="2"
          style={{
            color: "var(--gray-1)",
          }}
        >
          {Number(zoomLevel).toFixed(0)}%
        </Text>
        <ZoomButton onClick={onZoomIn}>
          <PlusCircledIcon />
        </ZoomButton>
      </Flex>

      <TextField.Root
        style={{
          width: "36px",
          height: "20px",
        }}
        onChange={(e) => {
          const newPage = parseInt(e.target.value);
          if (newPage > 0) {
            onPageChange?.(Math.min(newPage, totalPages));
          }
        }}
        defaultValue={currentPage}
      >
        <TextField.Slot side="right" pl="0">
          <Text color="gray">/{totalPages}</Text>
        </TextField.Slot>
      </TextField.Root>
    </Flex>
  );
};
